@if(showBreadcrumb){
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    @for (link of breadcrumb; track link.url; let i = $index) {
    <li class="breadcrumb-item">
      <a [routerLink]="link.url">
        {{link.label | titlecase}}
      </a>
    </li>
    }
  </ol>
</nav>

}
